// extracted by mini-css-extract-plugin
module.exports = {"EmptyPanel":"EmptyPanel--3XaRd"};